<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="onCreateWriter">{{generateCustomizeString('add')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="writerData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="writerListLoading">
        <el-table-column prop="id" :label="generateCustomizeString('writerId')">
        </el-table-column>
        <el-table-column prop="name" :label="generateCustomizeString('writerName')">
        </el-table-column>
        <el-table-column prop="code" :label="generateCustomizeString('writerCode')">
        </el-table-column>
        <el-table-column prop="writerLog" :label="generateCustomizeString('writerLog')">
          <template slot-scope="scope">
            <el-button size="small" @click="viewWriterLog(scope.$index)">{{generateCustomizeString('view')}}
            </el-button>
            <el-dialog :title="generateCustomizeString('writerLog')" :visible.sync="writerLogDialogVisible" width="80%" :append-to-body="true">
              <div style="margin-bottom: 20px;">
                <span>{{generateCustomizeString('writerName')}}: {{ writerName }}</span>
                <span style="margin-left: 30px;">{{generateCustomizeString('writerCode')}}: {{ writerCode }}</span>
              </div>
              <el-table
                :data="writerLogData"
                tooltip-effect="dark"
                style="width: 100%"
                v-loading="writerLogDataLoading"
              >
                <el-table-column prop="created_at" :label="generateCustomizeString('createdAt')"></el-table-column>
                <el-table-column prop="out_trade_no" :label="generateCustomizeString('orderId')">
                  <template slot-scope="scope">
                    <el-button
                      @click="viewOrderClick(scope.row)"
                      type="text"
                    >{{ scope.row.out_trade_no }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="message" :label="generateCustomizeString('comment')"></el-table-column>
              </el-table>
              <div style="margin-top: 10px; padding: 5px; background-color: #eee;">
                <el-pagination
                  @current-change="handleLogCurrentChange"
                  :current-page.sync="logCurrentPage"
                  :page-size="15"
                  layout="total, prev, pager, next"
                  :total="logCurrentTotal"
                ></el-pagination>
              </div>
            </el-dialog>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onEdit(scope.$index)">{{generateCustomizeString('editWriter')}}
            </el-button>
            <el-button type="text" size="small" @click="onRemoveWriter(scope.$index)">{{generateCustomizeString('delete')}}
            </el-button>
            <el-dialog :title="generateCustomizeString('editWriterDetail')" :visible.sync="updateWriterDialogVisible" width="40%" :append-to-body="true">
              <el-form ref="updateWriterForm" :model="updateWriterForm" label-width="25%">
                <div style="margin: 0 30px;">
                  <el-form-item :label="generateCustomizeString('writerId')">
                    <el-input v-model="updateWriterForm.id" style="width: 90%;" disabled></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('writerName')">
                    <el-input v-model="updateWriterForm.name" style="width: 90%;"></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('writerCode')">
                    <el-input v-model="updateWriterForm.code" style="width: 90%;" maxlength="4"></el-input>
                    <div v-if="updateNumberAlert === true" style="font-size: 13px; color: red;">{{generateCustomizeString('codeIsNumber') }}</div>
                  </el-form-item>
                  <el-form-item style="margin-top: 40px;">
                    <div>
                      <el-button @click="cancelUpdateWriter()" style="width: 80px;">{{generateCustomizeString('cancel') }}</el-button>
                      <el-button type="primary" @click="editWriter()" style="width: 80px; margin-left: 30px;">{{generateCustomizeString('confirm') }}</el-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </el-dialog>

            <el-dialog title="提示" :visible.sync="removeWriterDialogVisible" width="30%" :append-to-body="true">
              <span>{{ generateCustomizeString('confirmDelete') }}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="removeWriterDialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
                <el-button type="primary" @click="onConfirmDeleteAssistant()">{{ generateCustomizeString('confirm') }}</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-dialog
      :title="generateCustomizeString('addWriter')"
      :visible.sync="addWriterDialogVisible"
      width="50%"
      :append-to-body="true"
    >
      <el-form :model="addWriterForm" label-width="25%" ref="addWriterForm" style="padding: 0 20px;">
        <el-form-item :label="generateCustomizeString('writerName')">
          <el-input v-model="addWriterForm.name" style="width: 90%;"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('writerCode')">
          <el-input v-model="addWriterForm.code" style="width: 90%;" maxlength="4"></el-input>
          <div v-if="this.addNumberAlert === true" style="font-size: 13px; color: red;">{{generateCustomizeString('codeIsNumber') }}</div>
          <div v-else style="font-size: 13px; color: #aaa;">{{generateCustomizeString('fourNumber') }}</div>
        </el-form-item>
        <el-form-item style="margin-top: 40px;">
          <div>
            <el-button @click="cancelAddWriter()" style="width: 80px;">{{generateCustomizeString('cancel') }}</el-button>
            <el-button type="primary" @click="addWriterConfirm()" style="width: 80px; margin-left: 30px;">{{generateCustomizeString('confirm') }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'WriterCenter',
  data() {
    return {
      writerData: [],
      writerListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      logCurrentPage: 1,
      logCurrentTotal: 0,
      removeWriterDialogVisible: false,
      removeWriterId: null,
      editWriterId: null,
      viewWriterId: null,
      updateWriterDialogVisible: false,
      writerLogDialogVisible: false,
      writerLogData: [],
      writerLogDataLoading: false,
      addWriterDialogVisible: false,
      writerName: null,
      writerCode: null,
      addNumberAlert: false,
      updateNumberAlert: false,
      updateWriterForm: {
        id: '',
        name: '',
        code: ''
      },
      addWriterForm: {
        name: '',
        code: ''
      }
    }
  },
  methods: {
    generateCustomizeString,
    onCreateWriter() {
      this.addWriterDialogVisible = true
    },
    onRemoveWriter(index) {
      this.removeWriterDialogVisible = true
      this.removeWriterId = this.writerData[index].id
    },
    onEdit(index) {
      this.updateWriterDialogVisible = true
      this.editWriterId = this.writerData[index].id
      this.updateWriterForm.id = this.writerData[index].id
      this.updateWriterForm.name = this.writerData[index].name
      this.updateWriterForm.code = this.writerData[index].code
    },
    onConfirmDeleteAssistant() {
      if (this.removeWriterId >= 0) {
        this.fetchRemoveWriter(this.removeWriterId)
      }
    },
    onRefersh() {
      this.fetchWriterData(this.currentPage)
    },
    cancelAddWriter() {
      this.addWriterDialogVisible = false
      this.addNumberAlert = false
      this.addWriterForm.name = ''
      this.addWriterForm.code = ''
    },
    addWriterConfirm() {
      var num = /^\d+$/
      if (!num.test(this.addWriterForm.code)) {
        this.addNumberAlert = true
        return
      }

      var data = {
        name: this.addWriterForm.name,
        code: this.addWriterForm.code
      }
      request({
        url: '/writer',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.fetchWriterData(1)
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
        .finally(() => {
          this.addWriterDialogVisible = false
          this.addWriterForm.name = ''
          this.addWriterForm.code = ''
          this.addNumberAlert = false
        })
    },
    handleCurrentChange(val) {
      this.fetchWriterData(val)
    },
    handleLogCurrentChange(val) {
      this.fetchWriterLogData(val)
    },
    cancelUpdateWriter() {
      this.updateWriterDialogVisible = false
      this.updateNumberAlert = false
    },
    editWriter() {
      var num = /^\d+$/
      if (!num.test(this.updateWriterForm.code)) {
        this.updateNumberAlert = true
        return
      }

      request({
        url: 'writer/' + this.editWriterId,
        method: 'patch',
        data: {
          id: this.updateWriterForm.id,
          name: this.updateWriterForm.name,
          code: this.updateWriterForm.code
        }
      }).then(response => {
        this.fetchWriterData()
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.updateWriterDialogVisible = false
        this.updateNumberAlert = false
      })
    },
    fetchRemoveWriter() {
      if (this.writerListLoading) return
      this.writerListLoading = true
      request({
        url: 'writer/' + this.removeWriterId,
        method: 'delete'
      }).then(response => {
        console.info('writer remove success', response)
        this.removeWriterId = null
        this.removeWriterDialogVisible = false
        this.$message.success(this.generateCustomizeString('deletedSuccessfully'))
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.writerListLoading = false
        this.fetchWriterData(1)
      })
    },
    fetchWriterData(page) {
      if (this.writerListLoading) return
      this.writerListLoading = true
      request({
        url: 'writer/list',
        method: 'get',
        params: {
          page: page
        }
      }).then(response => {
        const meta = response.meta
        this.writerData = response.data
        this.currentPage = meta.current_page
        this.currentTotal = meta.total
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.writerListLoading = false
      })
    },
    viewWriterLog(index) {
      this.writerName = ''
      this.writerCode = ''
      this.writerLogDialogVisible = true
      this.viewWriterId = this.writerData[index].id
      this.writerName = this.writerData[index].name
      this.writerCode = this.writerData[index].code
      this.fetchWriterLogData(1)
    },
    fetchWriterLogData(page) {
      this.writerLogDataLoading = true

      request({
        url: '/writer/operation-logs',
        method: 'get',
        params: {
          writer_id: this.viewWriterId,
          page_size: 15,
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta

          this.writerLogData = data
          this.logCurrentPage = meta.current_page
          this.logCurrentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.writerLogDataLoading = false
        })
    },
    viewOrderClick(row) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: row.order_id }
      })
    }
  },
  created() {
    this.fetchWriterData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
</style>
